const PRIMARY_REGION = 'us-east-1'
const DR_REGION = 'us-west-2'

const currentRegion = process.env.REACT_APP_REGION || PRIMARY_REGION
const primaryRegionActive = process.env.REACT_APP_PRIMARY_REGION_ACTIVE !== 'down'

export const isDRRegion = currentRegion === DR_REGION
export const isPrimaryRegionActive = primaryRegionActive

export const isInDisasterMode = isDRRegion && !isPrimaryRegionActive

/**
 * DR Authentication rules:
 *
 * Case 1: Primary region is working (isDRRegion = true, isPrimaryRegionActive = true)
 *   - Sign In: Available (existing users only)
 *   - Sign Up: NOT available
 *   - Forgot Password: NOT available
 *
 * Case 2: Primary region is down (isDRRegion = true, isPrimaryRegionActive = false)
 *   - Sign In: Available, but user must click forgot password to reset password first
 *   - Sign Up: NOT available
 *   - Forgot Password: Available (existing users only)
 */
export const drAuthRules = {
  /**
   * Whether sign-up/registration is allowed
   * Disabled entirely in the DR region regardless of primary region status
   */
  isSignUpAllowed: !isDRRegion,

  /**
   * Whether forgot password is allowed
   * In DR region: only available when primary is DOWN (users need to reset password)
   * In primary region: always available
   */
  isForgotPasswordAllowed: !isDRRegion || !isPrimaryRegionActive,

  /**
   * Whether profile updates are allowed
   * Never allowed in DR region
   */
  isProfileUpdateAllowed: !isDRRegion,

  /**
   * Whether company/organization account updates are allowed from user side
   * (invite members, accept/reject requests, convert to org, manage branches, etc.)
   * Never allowed in DR region. Admin-side (Coltene admin) remains unaffected.
   */
  isCompanyAccountUpdateAllowed: !isDRRegion,
}

const drConfig = {
  isDRRegion,
  isPrimaryRegionActive,
  isInDisasterMode,
  currentRegion,
  PRIMARY_REGION,
  DR_REGION,
  drAuthRules,
}

export default drConfig
